'use client'

import React, { useContext, useEffect, useRef } from 'react'

import styles from './StableCoinScreen.module.scss'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import ItemContentSection4 from './ItemContentSection4'
import ReactPlayer from 'react-player'
import Button from 'components/Button'
import { ActionContext } from 'controller/context/ActionProvider'
import Dropdown from 'components/Dropdown'
import useResizeWidth from 'controller/useResizeWidth'
import images from 'assets/images'

const arrSection4 = [
  {
    title1: 'Love moves freely...',
    description:
      'Without the burden of intermediary costs and waiting time. Any son or daughter can support their family with ease, thanks to Stablecoins on Viction.',
    // 'Viction supports high transaction throughput, preventing network congestion even during peak activity.',
    image: images.moneyFree1,
  },
  {
    title1: 'Opportunities move freely...',
    description:
      'Without the volatility of interest rates, any investor can double their yield with speed and stability, thanks to Stablecoins on Viction.',
    image: images.moneyFree2,
  },
  {
    title1: 'Fandom moves freely…',
    description:
      'Beyond just streaming and likes. Fans can now truly support their favorite artists, owning exclusive moments and strengthening their connection through Stablecoins on Viction.',
    image: images.moneyFree3,
  },
  {
    title1: 'Indulgence moves freely…',
    description:
      'Without currency hassles or restrictions. Whether booking a stay or shopping abroad, travelers can enjoy seamless payments anywhere with Stablecoins on Viction.',
    image: images.moneyFree4,
  },
]

const arrSection6 = [
  {
    image: images.wspn,
  },
  {
    image: images.appPay1,
  },
  {
    image: images.appPay3,
  },
  {
    image: images.tether,
  },
  {
    image: images.oneId,
  },
  {
    image: images.starship,
  },
  {
    image: images.coin98,
  },
  {
    image: images.rabbit,
  },
  {
    image: images.dagora,
  },
]

function StableCoinScreen() {
  const { isTablet, positionY } = useResizeWidth()
  gsap.registerPlugin(ScrollTrigger)

  const { state, setState } = useContext(ActionContext)
  const { isVideoPlaying, isHideVideo, statusChoose, moneyChoose } = state
  const { setIsHideVideo, setIsVideoPlaying, setStatusChoose } = setState

  const homeWrapperRef = useRef()
  const section2Ref = useRef()
  const localMoneyRef = useRef()
  const section7Ref = useRef()
  const section3TitleRef = useRef()
  const section3ContentRef = useRef()
  const section5Ref = useRef()

  const section3ImgRef1 = useRef(null)
  const section3ImgRef2 = useRef(null)
  const section3ImgRef3 = useRef(null)
  const section3ImgRef4 = useRef(null)
  const section3ImgRef5 = useRef(null)
  const section3ImgRef6 = useRef(null)

  const section3ContentImgRef2 = useRef(null)
  const section3ContentImgRef3 = useRef(null)
  const section3ContentImgRef4 = useRef(null)
  const section3ContentImgRef5 = useRef(null)
  const section3ContentImgRef6 = useRef(null)

  const imgSection51 = useRef(null)
  const imgSection52 = useRef(null)
  const imgSection53 = useRef(null)
  const imgSection54 = useRef(null)
  const imgSection55 = useRef(null)
  const imgSection56 = useRef(null)

  const section7ContainerRef = useRef(null)
  const section7Text1Ref = useRef(null)

  const [isChangeDropdown, setIsChangeDropdown] = React.useState(false)
  const [isHideCoin, setIsHideCoin] = React.useState(false)

  const onChangeDropdown = () => {
    setIsChangeDropdown(!isChangeDropdown)
  }

  useEffect(() => {
    // gsap.set(homeWrapperRef.current, {
    //   opacity: 0,
    // })
    // gsap.to(section7Ref.current, {})

    gsap.set(section7ContainerRef.current, {
      scale: 0,
      opacity: 0,
    })
    gsap.fromTo(
      section7ContainerRef.current,
      { scale: 0, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        scrollTrigger: {
          trigger: '.section-7',
          start: 'top top',
          end: 'top 70%',
          // pin: true,
          // scrub: 1,
          toggleActions: 'play none reverse none',
        },
      }
    )

    gsap.set(section7Text1Ref.current, {
      opacity: 0,
    })
    gsap.to(section7Text1Ref.current, {
      opacity: 1,
      scrollTrigger: {
        trigger: '.section-7',
        start: 'top center',
        end: '+-1500',
        scrub: 1,
      },
    })
  }, [])

  useEffect(() => {
    if (!isTablet) {
      gsap.set(section3ImgRef1.current, {
        x: -200,
        opacity: 0,
      })
      gsap.set(section3ImgRef2.current, {
        x: -200,
        opacity: 0,
      })
      gsap.set(section3ImgRef3.current, {
        x: -200,
        opacity: 0,
      })
      gsap.set(section3ImgRef4.current, {
        x: -200,
        opacity: 0,
      })
      gsap.set(section3ImgRef5.current, {
        x: -200,
        opacity: 0,
      })
      gsap.set(section3ImgRef6.current, {
        x: -200,
        opacity: 0,
      })

      gsap.to(section3ImgRef1.current, {
        x: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3TitleRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })
      gsap.to(section3ImgRef2.current, {
        x: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3TitleRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })
      gsap.to(section3ImgRef3.current, {
        x: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3TitleRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })
      gsap.to(section3ImgRef4.current, {
        x: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3TitleRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })
      gsap.to(section3ImgRef5.current, {
        x: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3TitleRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })
      gsap.to(section3ImgRef6.current, {
        x: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3TitleRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })

      gsap.set(section3ContentImgRef2.current, {
        opacity: 0,
      })
      gsap.set(section3ContentImgRef3.current, {
        x: -150,
        opacity: 0,
      })
      gsap.set(section3ContentImgRef4.current, {
        x: -300,
        y: -100,
        opacity: 0,
      })
      gsap.set(section3ContentImgRef5.current, {
        x: -350,
        y: -150,
        opacity: 0,
      })
      gsap.set(section3ContentImgRef6.current, {
        x: -350,
        y: -200,
        opacity: 0,
      })

      gsap.to(section3ContentImgRef2.current, {
        x: 0,
        y: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3ContentRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })
      gsap.to(section3ContentImgRef3.current, {
        x: 0,
        y: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3ContentRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })
      gsap.to(section3ContentImgRef4.current, {
        x: 0,
        y: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3ContentRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })
      gsap.to(section3ContentImgRef5.current, {
        x: 0,
        y: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3ContentRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })
      gsap.to(section3ContentImgRef6.current, {
        x: 0,
        y: 0,
        opacity: 1,
        scrollTrigger: {
          trigger: section3ContentRef.current,
          start: 'top center',
          end: 'top bottom',
          // scrub: 1,
        },
      })

      gsap.set(imgSection52.current, {
        y: -270,
      })
      gsap.set(imgSection53.current, {
        y: -440,
      })
      gsap.set(imgSection54.current, {
        y: -560,
      })
      gsap.set(imgSection55.current, {
        y: -650,
      })
      gsap.set(imgSection56.current, {
        y: -670,
      })

      gsap.to(imgSection52.current, {
        y: 100,
        scrollTrigger: {
          trigger: '.section-5',
          start: 'top center',
          scrub: 1,
        },
      })
      gsap.to(imgSection53.current, {
        y: 100,
        scrollTrigger: {
          trigger: '.section-5',
          start: 'top center',
          scrub: 1,
        },
      })
      gsap.to(imgSection54.current, {
        y: 100,
        scrollTrigger: {
          trigger: '.section-5',
          start: 'top center',
          scrub: 1,
        },
      })
      gsap.to(imgSection55.current, {
        y: 100,
        scrollTrigger: {
          trigger: '.section-5',
          start: 'top center',
          scrub: 1,
        },
      })
      gsap.to(imgSection56.current, {
        y: 100,
        scrollTrigger: {
          trigger: '.section-5',
          start: 'top center',
          scrub: 1,
        },
      })
    } else {
      return null
    }
  }, [isTablet])

  useEffect(() => {
    if (isVideoPlaying) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
      setTimeout(() => {
        setIsHideVideo(true)
      }, 1000)
    }
  }, [isVideoPlaying])

  useEffect(() => {
    if (statusChoose === 'utilities') {
      section2Ref.current?.scrollIntoView()
    } else if (statusChoose === 'manifesto') {
      section7Ref.current?.scrollIntoView()
    } else if (statusChoose === 'buildUs') {
      section5Ref.current?.scrollIntoView()
    } else if (statusChoose === 'localMoney') {
      localMoneyRef.current?.scrollIntoView()
    }
  }, [statusChoose])

  useEffect(() => {
    const positionSection3 = section3TitleRef.current?.offsetParent.offsetTop
    if (positionY >= positionSection3) {
      setIsHideCoin(true)
    } else {
      setIsHideCoin(false)
    }
  }, [positionY])

  return (
    <>
      <div
        className={`video-intro-stable-coin ${
          !isVideoPlaying && 'video-intro-stable-coin--stop'
        } ${isHideVideo && 'video-intro-stable-coin--hide'}`}>
        <ReactPlayer
          url='media/intro.mp4'
          playing={true}
          loop={false}
          muted
          width='100%'
          height='100%'
          onEnded={() => setIsVideoPlaying(false)}
        />
      </div>

      <div className={styles.homeWrapper} ref={homeWrapperRef}>
        <div className='home-container'>
          <div className='home-banner-box'>
            <div className='home-banner'>
              <div className='banner-content'>
                <div
                  className={`banner-head ${
                    !isVideoPlaying && 'banner-head--show'
                  }`}>
                  <h1>Let your money move freely,</h1>
                  <h1>whenever you want!</h1>
                </div>

                <div
                  className={`banner-head-mobile ${
                    !isVideoPlaying && 'banner-head-mobile--show'
                  }`}>
                  <h1>Let your money move freely, whenever</h1>
                  <h1>you want!</h1>
                </div>

                <div
                  className={`banner-description ${
                    !isVideoPlaying && 'banner-description--show'
                  }`}>
                  We make your money move as seamlessly as the digital world—no
                  delays, no high fees, no barriers.
                </div>

                <div
                  className={`banner-button ${
                    !isVideoPlaying && 'banner-button--show'
                  }`}>
                  <Button
                    className='btn-custom'
                    variant='secondary'
                    onClick={() => setStatusChoose('localMoney')}>
                    Start using
                  </Button>
                  <Button
                    className='btn-custom'
                    onClick={() => setStatusChoose('buildUs')}>
                    Build with Us
                  </Button>
                </div>
              </div>

              {!isHideCoin && (
                <div className='coin-video'>
                  <ReactPlayer
                    url='media/coin-loop.mp4'
                    playing={true}
                    loop={true}
                    muted
                    width={'100%'}
                    height={'100%'}
                    className='video-coin'
                  />
                </div>
              )}
            </div>
          </div>

          {/* <div className='section-2' ref={section2Ref}>
            <div className='section-2-wrapper'>
              <div className='section-2-container'>
                <div className='section-2-title'>
                  <h2>We envision a world</h2>
                  <h2>where financial freedom is the standard</h2>
                </div>

                <div className='section-2-title-mobile'>
                  <h2>
                    We envision a world where financial freedom is the standard
                  </h2>
                </div>

                <div className='section-2-content'>
                  <div className='item-app'>
                    <div className='item-app--title'>Borderless payment</div>

                    <div className='item-app--description'>
                      Buy anything with stablecoins and crypto in just a
                      click—whether it’s shopping, gaming, NFTs, digital IDs,
                      and more.
                    </div>

                    <div className='item-app--icon'>
                      <img
                        src={appPay1}
                        alt='coin'
                        className='app-pay'
                      />
                    </div>
                  </div>

                  <div className='item-app'>
                    <div className='item-app--title'>Seamless On-Ramp</div>

                    <div className='item-app--description'>
                      Easily convert your local currency to stablecoins and
                      start engaging with the Web3 world instantly.
                    </div>

                    <div className='item-app--icon'>
                      <img
                        src={appPay2}
                        alt='coin'
                        className='app-pay'
                      />
                      <img
                        src={appPay3}
                        alt='coin'
                        className='app-pay'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className='section-3'>
            <div className='section-3-title' ref={section3TitleRef}>
              <div className='box-img'>
                <img
                  src={images.hand1}
                  alt=''
                  className='hand-img'
                  ref={section3ImgRef1}
                />

                <img
                  src={images.circle1}
                  alt=''
                  className='circle-img circle-img--img-1'
                  ref={section3ImgRef2}
                />

                <img
                  src={images.circle2}
                  alt=''
                  className='circle-img circle-img--img-2'
                  ref={section3ImgRef3}
                />

                <img
                  src={images.circle3}
                  alt=''
                  className='circle-img circle-img--img-3'
                  ref={section3ImgRef4}
                />

                <img
                  src={images.circle4}
                  alt=''
                  className='circle-img circle-img--img-4'
                  ref={section3ImgRef5}
                />

                <img
                  src={images.imgCoin}
                  alt=''
                  className='circle-img circle-img--coin'
                  ref={section3ImgRef6}
                />
              </div>

              <div className='title-box'>
                <h1>Move Money Freely</h1>
                <h1>with Viction</h1>
              </div>
            </div>

            <div className='section-3-content' ref={section3ContentRef}>
              <div className='content-container'>
                <div className='content-text'>
                  Viction is shaping a world where money moves freely—instant,
                  affordable, and accessible to all.
                </div>
              </div>

              <div className='box-img-bottom'>
                <img src={images.hand2} alt='' className='hand-img' />

                <img
                  src={images.circleDown1}
                  alt=''
                  className='circle-img circle-img--img-1'
                  ref={section3ContentImgRef2}
                />

                <img
                  src={images.circleDown2}
                  alt=''
                  className='circle-img circle-img--img-2'
                  ref={section3ContentImgRef3}
                />

                <img
                  src={images.circleDown3}
                  alt=''
                  className='circle-img circle-img--img-3'
                  ref={section3ContentImgRef4}
                />

                <img
                  src={images.circleDown4}
                  alt=''
                  className='circle-img circle-img--img-4'
                  ref={section3ContentImgRef5}
                />

                <img
                  src={images.imgCoin}
                  alt=''
                  className='circle-img circle-img--coin'
                  ref={section3ContentImgRef6}
                />
              </div>
            </div>
          </div>

          <div className='section-local-money' ref={localMoneyRef}>
            <div className='local-money-container'>
              <div className='local-item local-item--left'>
                <img src={images.localCity} alt='' className='local-img' />

                <div className='text-local'>
                  Local Money ⇆ Stablecoins on Viction
                </div>

                <div
                  className={`button-local ${
                    isChangeDropdown && 'button-local--dropdown'
                  }`}>
                  {!isChangeDropdown ? (
                    <Button variant='secondary' onClick={onChangeDropdown}>
                      <span className='icon-swap'></span> Start Convert
                    </Button>
                  ) : (
                    <Dropdown />
                  )}
                </div>

                {moneyChoose && (
                  <div className='text-item-choose'>
                    <div className='text-choose'>
                      {moneyChoose.value === 'vnd'
                        ? 'You can convert your VND to USDT VRC25 via:'
                        : 'You can convert USDT VRC25 to VND/ THB/ PHP/ IDR via:'}
                    </div>

                    <a
                      href='https://ramp.aliniex.com/en'
                      target='_blank'
                      rel='nofollow'>
                      <div className='choose-pay'>
                        <img
                          src={images.alixPay}
                          alt=''
                          className='img-choose'
                        />
                        Alix Pay
                      </div>
                    </a>
                  </div>
                )}
              </div>
              <div className='local-item local-item--right'>
                <div className='text-right-local'>
                  <div className='title-right-local'>
                    Enjoy Viction&apos;s Zero Gas Fee Feature
                  </div>

                  <div className='description-right-local'>
                    Unlike most chains, Viction removes gas fees so you own
                    more, pay less.
                  </div>
                </div>

                <div className='img-right'>
                  <img src={images.zeroGas} alt='' className='local-img-zero' />
                </div>
              </div>
            </div>
          </div>

          <div className='section-4'>
            <div className='section-4-container'>
              <div className='section-4-title'>
                <h1>How We Enable</h1>

                <h1>Money Free Movement</h1>
              </div>

              <div className='section-4-content'>
                {arrSection4.map((item, index) => {
                  return <ItemContentSection4 key={index} item={item} />
                })}
              </div>
            </div>
          </div>

          <div className='section-5' ref={section5Ref}>
            <img src={images.bgWhite} alt='' className='bg-white' />

            <div className='section-5-container'>
              <div className='section-5-title-mobile'>
                <h1>
                  We look forward to
                  <span>innovators and builders</span> joining us!
                </h1>
              </div>

              <div className='section-5-title'>
                <h1>We look forward to</h1>

                <h1>
                  <span>innovators and builders</span>
                </h1>

                <h1>joining us!</h1>
              </div>

              <div className='section-5-img'>
                <img
                  src={images.circle51}
                  alt=''
                  className='circle-down circle-down--img-1'
                  ref={imgSection51}
                />
                <img
                  src={images.circle52}
                  alt=''
                  className='circle-down circle-down--img-2'
                  ref={imgSection52}
                />
                <img
                  src={images.circle53}
                  alt=''
                  className='circle-down circle-down--img-3'
                  ref={imgSection53}
                />
                <img
                  src={images.circle54}
                  alt=''
                  className='circle-down circle-down--img-4'
                  ref={imgSection54}
                />
                <img
                  src={images.circle54}
                  alt=''
                  className='circle-down circle-down--img-5'
                  ref={imgSection55}
                />
                <img
                  src={images.imgCoin}
                  alt=''
                  className='circle-down circle-down--img-coin'
                  ref={imgSection56}
                />
              </div>

              <div className='section-5-img-mobile'>
                <img
                  src={images.circle51}
                  alt=''
                  className='circle-down circle-down--img-1'
                />
                <img
                  src={images.circle52}
                  alt=''
                  className='circle-down circle-down--img-2'
                />
                <img
                  src={images.circle53}
                  alt=''
                  className='circle-down circle-down--img-3'
                />
                <img
                  src={images.circle54}
                  alt=''
                  className='circle-down circle-down--img-4'
                />
                <img
                  src={images.circle54}
                  alt=''
                  className='circle-down circle-down--img-5'
                />
                <img
                  src={images.imgCoin}
                  alt=''
                  className='circle-down circle-down--img-coin'
                />
              </div>

              <div className='section-5-content'>
                <div className='content-box'>
                  <div className='content-text'>
                    <p>
                      We are calling on Stablecoins, financial innovators, who
                      share our vision of frictionless, inclusive, and scalable
                      financial solutions.
                    </p>
                    <p>
                      Viction provides the infrastructure and ecosystem you need
                      to scale and succeed.
                    </p>
                  </div>

                  <div className='content-button'>
                    <a
                      href='https://forms.gle/CH3pGKQT16FdJ97L8'
                      target='_blank'
                      rel='nofollow'>
                      <Button className='btn-custom' variant='secondary'>
                        Contact us
                      </Button>
                    </a>
                    <a href='https://viction.xyz' target='_blank'>
                      <Button className='btn-custom'>
                        Learn more about Viction
                      </Button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='section-6'>
            <div className='section-6-container'>
              <div className='section-6-title'>
                <h2>Our Global Network of Innovators</h2>
              </div>

              <div className='section-6-content'>
                <div className='content-box'>
                  <div className='line'></div>

                  {arrSection6.map((item, index) => {
                    return (
                      <div className='logo-img' key={index}>
                        <img src={item.image} alt='' className='logo' />
                      </div>
                    )
                  })}
                  <div className='line line--line-2'></div>
                </div>
              </div>
            </div>
          </div>
          {/* 
          <div className='section-7' ref={section7Ref}>
            <Zoom delay={500}>
              <div className='section-7-container'>
                <div className='video'></div>

                <div className='section-7-content'>
                  <div className='content-section'>
                    <h1 className='section-7-title'>Our Manifesto</h1>
                  </div>

                  <div
                    className='content-section content-section--section-2'
                    ref={section7Text1Ref}>
                    <div className='text'>
                      Power of money does not lie at how much we own & earn, but
                      at how far we can reach those in need, how grandly we can
                      construct, and how freely we can move forward.
                    </div>
                  </div>

                  <div className='content-section content-section--section-3'>
                    <div className='text'>
                      At Viction, we believe money should move freely,
                      unrestricted by borders, privilege or status.
                      <br />
                      <br />
                      We envision a world where everyone has a rightful place in
                      asset exchange — where money moves with intention,
                      empowering us to enhance livelihood of our family,
                      community and society.
                    </div>
                  </div>

                  <div className='content-section content-section--section-4'>
                    <div className='text'>
                      Stablecoin Economy on Viction is a movement of Freedom —
                      the freedom to choose your path, to care for who matters
                      the most, and to build a life on your own terms.
                    </div>
                  </div>
                </div>
              </div>
            </Zoom>
          </div> */}

          <div className='section-8'>
            <div className='section-8-container'>
              <div className='section-text'>
                <h1 className='section-text--title'>Make every move count!</h1>

                <div className='section-text--coming'>Coming soon...</div>
              </div>

              <div className='img-background'>
                <img
                  src={images.walkOut1}
                  alt=''
                  className='img-bg img-bg--img-1'
                />
                <img
                  src={images.walkOut2}
                  alt=''
                  className='img-bg img-bg--img-2'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StableCoinScreen
